import { ACT_USR_CHANGE } from "./ActionTypes";
import UserService from "../provider/user/UserService";
import {loading} from "./AppActions"
import MediaService from "../provider/media/MediaService";

/*** ACTIONS USERS ******/
export function actionGetUsers(succesCallback, errorCallback) {
    return (dispatch, getStore) => {
				loading(true)(dispatch, getStore)
        UserService.getUsers(getStore().app.app).then((response) => {
            dispatch({
                type:ACT_USR_CHANGE,
                props: {userList:response}
						})
            succesCallback()
        }).catch(errorCallback)
        .finally(()=>{loading(false)(dispatch, getStore)})
    };
}

export function actionGetUsersByEmailOrDU(usersDU, usersEmail, succesCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      UserService.getUsersByEmailOrDU(getStore().app.app, usersDU, usersEmail).then((response) => {
          // dispatch({
          //   type:ACT_USR_CHANGE,
          //   props: {user:response}
          // })
          succesCallback(response)
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

export function actionGetUsersFromExcel(file, successCallback, errorCallback){
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore)
    MediaService.uploadFile(file, 'temp', 'excel').then(res => {
      loading(true)(dispatch, getStore)
      UserService.getUsersFromStorage(res.path, res.filename).then((response)=>{
        console.log("RESPONSE", response)
        successCallback(response)
      }).finally(()=>{
                  MediaService.deleteFile(res.path)
                  loading(false)(dispatch, getStore)
                })
    }).catch(errorCallback)
    .finally(()=>{loading(false)(dispatch, getStore)})
  }
}


export function actionSaveUser(user, successCallback, errorCallback) {
    return (dispatch, getStore) => {
        loading(true)(dispatch, getStore)
        UserService.saveUser(getStore().app.app, user).then((response) => {
          successCallback()
        }).catch(errorCallback)
        .finally(()=>{loading(false)(dispatch, getStore)})
       
    };
}

export function actionDeleteUser(user, successCallback, errorCallback) {
  return (dispatch, getStore) => {
      loading(true)(dispatch, getStore)
      UserService.deleteUser(getStore().app.app, user.id).then((response) => {
        successCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
  };
}


export function actionSendNotification(user, notification, successCallback, errorCallback){
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore)
    if(notification.image&&notification.image!={}){
      MediaService.uploadFile(notification.image, 'temp', 'image').then(res => {
        notification.image=res.downloadURL
        UserService.sendNotification(getStore().app.app, user, notification).then((response) => {
          successCallback()
        }).catch(errorCallback)
        .finally(()=>{MediaService.deleteFile(res.path)})
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
    }else{
      UserService.sendNotification(getStore().app.app, user, notification).then((response) => {
        successCallback()
      }).catch(errorCallback)
      .finally(()=>{loading(false)(dispatch, getStore)})
    }
    
  };
}
/****** FIN ACTION USERS +**********/




// WEBPACK FOOTER //
// ./src/actions/UserActions.js